import React from "react";
import { connect } from "react-redux";
import { getSectionBreakLinesColor } from "../../../redux/selectors/template";

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapStateToProps = (state, ownProps) => {
    return {
        sectionBreakLinesColor: getSectionBreakLinesColor(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {{navigation: *}}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

/**
 * Component to display a section style break line (with settings from AN-07b - full width)
 * @param props
 * @returns {*}
 * @constructor
 */
export const SectionBreakLine = connect(
    mapStateToProps,
    mapDispatchToProps
)(props => {
    return (
        <div>
            <div className="section-spacer" />
            <div
                className="section-break-line"
                style={{
                    borderColor: props.sectionBreakLinesColor,
                }}
            />
        </div>
    );
});

/**
 * Component to display an article style break line (with settings from AN-07b - NOT full width)
 * @param props
 * @returns {*}
 * @constructor
 */
export const ArticleBreakLine = connect(
    mapStateToProps,
    mapDispatchToProps
)(props => {
    return (
        <div>
            <div className="article-spacer" />
            <div
                className="article-break-line"
                style={{
                    borderColor: props.sectionBreakLinesColor,
                }}
            />
        </div>
    );
});
